import { mediaQuery } from 'constants/ui';

export const getStyles = ({ palette }, { isCollapsed } = {}) => {
  return {
    accordion: {
      '&.MuiAccordion-root': {
        borderRadius: '12px',
        marginTop: 0,
      },
      '& .MuiAccordionSummary-content': {
        margin: '0',
      },
      '& .MuiAccordionSummary-root': {
        padding: '0',
      },
      '& .MuiAccordionDetails-root': {
        flexDirection: 'column',
        padding: '0 2rem',
      },
    },
    activities: {
      flex: 1,

      // The list+contacts pane is a fixed-width sidebar next to the activity list on
      // desktop; on mobile it cannot sit side-by-side, so stack them vertically.
      [mediaQuery.mobile]: {
        flexDirection: 'column',
      },
    },
    contactsColumn: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      width: '230px',
      minWidth: isCollapsed ? '' : '230px',
      color: palette.text.primary,
      backgroundColor: palette.background.paper,
      borderRight: `1px solid ${palette.divider}`,

      [mediaQuery.mobile]: {
        width: '100%',
        minWidth: '100%',
        height: 'auto',
        borderRight: 'none',
        borderBottom: `1px solid ${palette.divider}`,
      },
    },
    borrowerBlock: {
      borderBottom: `1px solid ${palette.divider}`,
    },
    themeTextColor: {
      // overriding unwanted 'white-space: pre' styles to avoid layout breaking
      '& *': {
        whiteSpace: 'normal !important',
      },
      // CKEditor wraps text blocks with tables and with style (not inline)
      '& td': {
        color: `${palette.text.primary} !important`,
      },
    },
    emailContent: {
      // style from CKEditor
      '& blockquote': {
        overflow: 'hidden',
        paddingRight: '1.5em',
        paddingLeft: '1.5em',
        marginLeft: '0',
        marginRight: '0',
        fontStyle: 'italic',
        borderLeft: '5px solid #ccc',
      },
    },
    addButton: {
      top: -20,
      right: 24,
      transform: 'scaleX(0.8) scaleY(0.8)',
    },
    emailItem: {
      '&.MuiAccordion-root': {
        margin: 0,
      },
    },
    emailActions: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr 1fr',
      gridTemplateAreas: `
        "replyBtn replyAllBtn forwardBtn"
      `,

      '& > .MuiToggleButton-root': {
        borderWidth: '0 0 0 1px',
        borderRadius: 0,
      },
    },
    replyBtn: {
      gridArea: 'replyBtn',
    },
    replyAllBtn: {
      gridArea: 'replyAllBtn',
      '& span': {
        whiteSpace: 'nowrap',
      },
    },
    forwardBtn: {
      gridArea: 'forwardBtn',
    },
    textColor: {
      color: 'secondary.main',
    },
  };
};
